module.exports = __webpack_public_path__ + "img/22fb495.svg";